import { Link } from "react-router-dom";

function NavList() {
  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <ul className="flex gap-9 text-white text-[16px] font-bold xl:none">
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/"}>
            Home
          </Link>
        </li>
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/about"}>
            About Us
          </Link>
        </li>
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/trainings"}>
            Trainings
          </Link>
        </li>
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/equipments"}>
            Equipments
          </Link>
        </li>
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/pricing"}>
            Pricing
          </Link>
        </li>
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/gallery"}>
            Gallery
          </Link>
        </li>
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/testimonials"}>
            Testimonials
          </Link>
        </li>
        <li style={{ transition: "all 0.3s" }} className="cursor-pointer hover:text-[#ffd600]">
          <Link onClick={goTop} to={"/contact"}>
            Contact
          </Link>
        </li>
      </ul>
    </>
  );
}

export default NavList;
